export enum NavigationTabTotalWealth {
    TOTAL_WEALTH = 'TOTAL_WEALTH',
    ASSETS = 'ASSETS',
    LIABILITIES = 'LIABILITIES',
    INCOME_AND_EXPENSES = 'INCOME_AND_EXPENSES',
}

export enum SubNavigationTabTotalWealth {
    WEALTH_OVERVIEW,
    CASHFLOWS,
}
